import { render } from "./OverviewPage.vue?vue&type=template&id=25df42a6&scoped=true&ts=true"
import script from "./OverviewPage.vue?vue&type=script&lang=ts"
export * from "./OverviewPage.vue?vue&type=script&lang=ts"

import "./OverviewPage.vue?vue&type=style&index=0&id=25df42a6&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25df42a6"]])

export default __exports__